import {PromoCode} from '@domain/model/Account/PromoCode/PromoCode';

const GetRemainingApplicableOrders =
  () =>
  (promoCode: PromoCode): number => {
    return promoCode.applicableOrders > 1
      ? promoCode.remainingApplicableOrders + 1
      : promoCode.remainingApplicableOrders;
  };

export {GetRemainingApplicableOrders};
